export const diagnosticsHealthColor = (level?: string): 'success' | 'warning' | 'error' | 'default' | 'info' => {
  switch (level) {
    case 'healthy': return 'success';
    case 'warning': return 'warning';
    case 'critical': return 'error';
    case 'info': return 'info';
    default: return 'default';
  }
};
